import {
  IStructuredSuggestions, ISuggest,
} from '@cian/api-models/suggest/v2/suggest';

export const SUGGESTION_TYPE_MAP: {[index: string]: string } = {
  company: 'builder',
  builder: 'builder',
  newbuilding: 'newobject',
  newbuildings: 'newobject',
  district: 'district',
  districts: 'district',
  underground: 'underground',
  undergrounds: 'underground',
};

export interface  ISearchAutocompleteUndergroundLine {
  lineColor: string; //HEX без #
  lineId: number;
  lineName: string;
}

export interface ISearchAutocompleteItem {
  type: 'underground' | 'newbuilding' |'district' | 'company' | 'builder';

  id: number;
  regionId: number;
  name: string;
  fullName: string;
  matches: number[];

  //underground
  lines?: Array<ISearchAutocompleteUndergroundLine>;
  underConstruction?: boolean;

  //newbuilding
  address?: string;
  link?: string;
}

export interface INewbuildingStructuredSuggestions extends IStructuredSuggestions {
  builders: ISuggest<ISearchAutocompleteItem>;
}

export interface IGeoSuggestResponseScheme {
  status: 'ok';
  data: IMultiSuggestResult;
}

interface IMultiSuggestResult {
  suggestions: INewbuildingStructuredSuggestions;
  sortOrder: string[];
}

export function extractSuggestion<
  INewbuildingStructuredSuggestions,
  TEntityType extends keyof INewbuildingStructuredSuggestions
  >(suggestions: INewbuildingStructuredSuggestions, type: TEntityType) {
  //@ts-ignore
  //Не видит items, хотя в INewbuildingStructuredSuggestions он есть
  const oneSection = suggestions[type] ? suggestions[type].items : [];
  const isNewbuildingsType = type === 'newbuildings';

  return oneSection
  //@ts-ignore
  //Не видит items, хотя в INewbuildingStructuredSuggestions он есть
    .map(item => {
      const itemName = isNewbuildingsType ? `ЖК «${item.name}»` : item.name;

      return {
        title: itemName,
        displayName: itemName,
        type: SUGGESTION_TYPE_MAP[item.type],
        value: String(item.id),
        dataType: 'simple',
        url: item.link,
        fullAddress: item.address,
        undergroundLines: item.lines,
      };
    });
}
